import { LifetimeMortgageApplication } from '@/service';

/**
 * @class @name Application
 * @description Exposes menu store module
 */
export default class Application {
	/**
	 * @method @static @get @name namespaced
	 * @description Is this module namespaced?
	 */
	static get namespaced() {
		return true;
	}

	/**
	 * @method @static @get @name state
	 * @description Expose state as an object, compatible with vue stores
	 */
	static get state() {
		return {};
	}

	/**
	 * @method @static @get @name getters
	 * @description Expose getters as an object, compatible with vue stores
	 */
	static get getters() {
		return {};
	}

	/**
	 * @method @static @get @name mutations
	 * @description Expose mutations as an object, compatible with vue stores
	 */
	static get mutations() {
		return {};
	}

	/**
	 * @method @static @get @name actions
	 * @description Expose action as an object, compatible with vue stores
	 */
	static get actions() {
		return {
			/**
			 * @async @name fetchApplicationList
			 * @param {Object} context
			 * @param {Object} payload
			 */
			fetchApplicationList(context, payload) {
				return LifetimeMortgageApplication.list(payload);
			},

			/**
			 * @async @name submitApplication
			 * @param {Object} context
			 * @param {Object} payload
			 */
			submitApplication(context, payload) {
				return LifetimeMortgageApplication.post(payload);
			}
		};
	}
}
